import React from 'react';

// Structural Layout Components matching Reference Image
import Hero from './components/Hero';
import QuickActions from './components/QuickActions';
import UpdatesRow from './components/UpdatesRow';
import MissionStatsRow from './components/MissionStatsRow';
import BishopMessage from './components/BishopMessage';
import MediaRow from './components/MediaRow';
import Newsletter from './components/Newsletter';

export default function Home({ activeSection = 'home', onSelectSection = () => { } }) {
  return (
    <div className="min-h-screen bg-white text-[#1A1A1A] font-sans selection:bg-[#842343]/20 selection:text-[#842343]">
      {/* Row 1: Hero & Floating Scripture Box */}
      <Hero onSelectSection={onSelectSection} />
      
      {/* Row 2: 8 Quick Actions */}
      <QuickActions onSelectSection={onSelectSection} />
      
      {/* Row 3: Latest News | Upcoming Events | Prayer Wall */}
      <UpdatesRow onSelectSection={onSelectSection} />
      
      {/* Row 4: Our Mission | Statistics */}
      <MissionStatsRow onSelectSection={onSelectSection} />
      
      {/* Row 5: Bishop Pastoral Message */}
      <BishopMessage onSelectSection={onSelectSection} />

      {/* Row 6: Live Streaming | Moments of Faith Gallery */}
      <MediaRow onSelectSection={onSelectSection} />
      
      {/* Row 7: Stay Connected Newsletter */}
      <Newsletter />
    </div>
  );
}
